import { Injectable } from '@angular/core'
import { Meta, Title } from '@angular/platform-browser'

import { ConfigurationService } from 'src/app/services/configuration.service'
import { UtilityService } from 'src/app/services/utility.service'

interface IMetaItem {
    name: string
    content: string
    element: string // 'meta', 'title', or 'structuredData'
}

interface IMetaConfigs {
    default: Record<string, string>
    tags: Array<IMetaItem>
    meta_group: Array<Record<string, Array<IMetaItem>>>
    url: Array<{ path: string, meta_group: string }>
}

@Injectable({
    providedIn: 'root'
})
export class SeoService {
    private currentUrl: string
    private metaConfigs: IMetaConfigs
    private baseUrl: string

    constructor( private meta: Meta,
                 private configurationService: ConfigurationService,
                 private titleService: Title,
               ){
        this.configurationService
            .$configuration
            .subscribe((config) => {
                this.metaConfigs = this.configurationService.getConfig('catalog.seo', null)
                this.baseUrl = this.configurationService.getConfig( 'catalog.image_base_url', null )
            })
    }


    public update(path: string, data: any) {
        if (path.split('?')[0] !== this.currentUrl) {
            this.currentUrl = path
            this.updateMeta(path.split('?')[0], data)
        }
    }

    private updateMeta(path: string, data: any) {
        if (!this.metaConfigs) {
            this.metaConfigs = this.configurationService.getConfig('catalog.seo', null)
        }

        const key = this.metaConfigs.url.find(metakey => path.includes(metakey.path))

        this.metaConfigs.tags.forEach(metaItem => {
            this.updateContent( metaItem, {} )
        })

        if ( key && data[key.meta_group].getValue() ) {
            this.metaConfigs.meta_group[key.meta_group].forEach( ( metaTag: IMetaItem ) => {
               this.updateContent( metaTag, data[key.meta_group].getValue() )
            })
        }
    }


    private updateContent(metaTag: IMetaItem, storeData: any) {
        switch (metaTag.element) {
            case 'meta':
                this.meta.updateTag({ name: metaTag.name, content: this.getMetaContent(metaTag.content, storeData, metaTag.name) })
                break
            case 'title':
                this.titleService.setTitle(UtilityService.replaceTemplate(metaTag.content, storeData))
                break
        }
    }

    setStructuredData(assetData: any) {
        const data = [{
            "@context": "http://schema.org",
            "@type": "Product",
            "brand": assetData.make,
            "model": assetData.model,
            "name": `${assetData.make} ${assetData.model}`,
            "category": assetData.category,
            "description": assetData.detailed_description,
            "image": assetData.images && assetData.images.length ? `${ this.baseUrl ?? '/' }?type=ItemDetailBig&guid=${assetData.images[0]}` : '',
            "offers": {
                "@type": "Offer",
                "price": assetData.list_price ? assetData.list_price : '',
                "priceCurrency": assetData.list_price_native_currency,
                "availability": "InStock",
                "url": document.location.href,
                "seller": {
                "@type": "Organization",
                "name": this.titleService.getTitle()
                },
                "itemCondition": "UsedCondition"
            }
        }, {
            '@context': 'http://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
            {
                '@type': 'ListItem',
                position: 1,
                item: {
                '@id': document.location.origin,
                name: 'Home',
                },
            },
            {
                '@type': 'ListItem',
                position: 2,
                item: {
                '@id': document.location.origin + '/equipment/search?equipment.filter_sub_category=' + assetData.sub_category,
                name: 'Search',
                },
            },
            {
                '@type': 'ListItem',
                position: 3,
                item: {
                '@id': document.location.origin + document.location.pathname,
                name: assetData.year + ' ' + assetData.make + ' ' + assetData.model,
                },
            },
            ],
        }]
        const scriptId = 'seo-structured-data'
        let scriptTag = document.getElementById(scriptId) as HTMLScriptElement | null
        if (!scriptTag) {
            scriptTag = document.createElement('script')
            scriptTag.type = 'application/ld+json'
            scriptTag.id = scriptId
            document.head.appendChild(scriptTag)
        }
        scriptTag.textContent = JSON.stringify(data)
    }

    private getMetaContent( template: string, data, name = '') {
        if( name.includes('image') ) {
            if( data.images && data.images.length ) {
                data.img = data.images[0]
            } else {
                template = this.metaConfigs.default[name] ? this.metaConfigs.default[name] : template
            }
        }

        return UtilityService.replaceTemplate( template, data )
    }
}
